export enum Breakpoints {
  Handset,
  Tablet,
  Web,
}
